// This file is auto-generated by @oracle/oraclejet-icu-l10n from src/resources/icu/bundle.json
// and should not be edited by hand. Update the JSON file and rerun the build to regenerate this content.

const bundle = {
  accAnnounceMovedKey: (p: { itemKey: string; position: string; referenceKey: string }) =>
    '[PX][Moved ' + p['itemKey'] + ' ' + p['position'] + ' ' + p['referenceKey'] + '. éëžéëžé]',
  accCommandKey: () => '[PX][Command é]',
  accControlKey: () => '[PX][Close é]',
  accPositionAfter: () => '[PX][after é]',
  accPositionBefore: () => '[PX][before é]',
  accReorderInstructions: (p: { keyPressed: string }) =>
    '[PX][Press and hold ' +
    p['keyPressed'] +
    ' and shift keys, then use the arrow keys to reorder. éëžéëžéëžéëžéëžéëž]',
  calendarDateConverter_parseError: (p: { dateExample: string }) =>
    '[PX][Enter a complete date like this: ' + p['dateExample'] + '. éëžéëžéëž]',
  calendarMonthConverter_parseError: (p: { dateExample: string }) =>
    '[PX][Enter a month and year like this: ' + p['dateExample'] + '. éëžéëžéëž]',
  chart_labelGroup: () => '[PX][Group é]',
  chart_labelSeries: () => '[PX][Series é]',
  chart_labelValue: () => '[PX][Value é]',
  checkboxSet_requiredMessageDetail: () => '[PX][Required é]',
  checkbox_requiredMessageDetail: () => '[PX][Required é]',
  close: () => '[PX][Close é]',
  collection_noData: () => '[PX][No data to display. é]',
  collection_selectAllRows: () => '[PX][Select all rows é]',
  collection_selectRow: (p: { ROW_NAME: string }) => '[PX][Select row ' + p['ROW_NAME'] + ' é]',
  collection_sortDisabled: () => '[PX][Not sortable é]',
  collection_sortEnabled: () => '[PX][Sortable é]',
  confirmation: () => '[PX][Confirmation é]',
  datePicker_currentDate: () => '[PX][Current date é]',
  datePicker_goToToday: () => '[PX][Go to today é]',
  datePicker_label: () => '[PX][Date Picker é]',
  datePicker_month: () => '[PX][Month é]',
  datePicker_months: () => '[PX][Months é]',
  datePicker_next: () => '[PX][Next é]',
  datePicker_nextDecade: () => '[PX][Next decade é]',
  datePicker_nextMonth: () => '[PX][Next month é]',
  datePicker_prev: () => '[PX][Previous é]',
  datePicker_prevDecade: () => '[PX][Previous decade é]',
  datePicker_prevMonth: () => '[PX][Previous month é]',
  datePicker_restricted: () => '[PX][Restricted é]',
  datePicker_selected: () => '[PX][Selected é]',
  datePicker_today: () => '[PX][Today é]',
  datePicker_weekNum: (p: { NUM: string }) => '[PX][Week ' + p['NUM'] + ' é]',
  datePicker_weekNumColLabel: () => '[PX][Week Number é]',
  datePicker_year: () => '[PX][Year é]',
  datePicker_years: () => '[PX][Years é]',
  error: () => '[PX][Error é]',
  expandableList_expandCollapseInstructionText: () =>
    '[PX][Use arrow keys to expand and collapse éëžéëž]',
  expandableList_groupCollapse: () => '[PX][Collapsed é]',
  expandableList_groupExpand: () => '[PX][Expanded é]',
  filePicker_addFiles: () => '[PX][Add Files é]',
  filePicker_dropzonePrimaryText: () => '[PX][Drag and Drop é]',
  filePicker_dropzoneSecondaryText: () => '[PX][Select a file or drop one here éëžé]',
  filePicker_dropzoneSecondaryTextMultiple: () => '[PX][Select or drop files here éë]',
  filePicker_multipleFileTypeUploadError: (p: { fileTypes: string }) =>
    "[PX][You can't upload files of type: " + p['fileTypes'] + ' éëžéëžé]',
  filePicker_singleFileUploadError: () => '[PX][Upload one file at a time éë]',
  filePicker_singleTypeUploadError: (p: { fileType: string }) =>
    "[PX][You can't upload files of type " + p['fileType'] + ' éëžéëžé]',
  filePicker_unknownFileTypeUploadError: () => '[PX][unknown é]',
  formControl_clear: () => '[PX][Clear é]',
  formControl_day: () => '[PX][Day é]',
  formControl_helpAvailable: () => '[PX][Help available é]',
  formControl_hide: () => '[PX][Hide é]',
  formControl_limitReached: (p: { CHARACTER_LIMIT: number }) =>
    '[PX][You’ve reached the ' +
    ((
      {
        one: new Intl.NumberFormat('en-XA').format(p['CHARACTER_LIMIT']) + '-character'
      } as Partial<Record<Intl.LDMLPluralRule, string>>
    )[new Intl.PluralRules('en-XA').select(p['CHARACTER_LIMIT'])] ||
      new Intl.NumberFormat('en-XA').format(p['CHARACTER_LIMIT']) + '-character') +
    ' limit. éëžéëžéëžéëžéëžéëžéëžé]',
  formControl_loading: () => '[PX][Loading é]',
  formControl_maxLength: (p: { MAX_LENGTH: string }) =>
    '[PX][You can enter up to ' + p['MAX_LENGTH'] + ' characters. éëžéëžéë]',
  formControl_maxLengthRemaining: (p: { CHARACTER_COUNT: string }) =>
    '[PX][' + p['CHARACTER_COUNT'] + ' characters left. éëžéë]',
  formControl_month: () => '[PX][Month é]',
  formControl_readOnly: () => '[PX][Read only é]',
  formControl_requiredMessageDetail: () => '[PX][Enter a value. é]',
  formControl_show: () => '[PX][Show é]',
  formControl_year: () => '[PX][Year é]',
  gantt_labelDate: () => '[PX][Date é]',
  gantt_labelEnd: () => '[PX][End é]',
  gantt_labelLabel: () => '[PX][Label é]',
  gantt_labelRow: () => '[PX][Row é]',
  gantt_labelStart: () => '[PX][Start é]',
  indexer_disabledLabel: (p: { SECTION: string }) =>
    '[PX][' + p['SECTION'] + '. No matching section found. éëžéëž]',
  indexer_keyboardInstructionText: () => '[PX][Press enter to select value. éëž]',
  indexer_othersLabel: () => '#',
  indexer_separatorLabel: (p: { FROM_SECTION: string; TO_SECTION: string }) =>
    '[PX][Between ' + p['FROM_SECTION'] + ' and ' + p['TO_SECTION'] + '. éëžéëžé]',
  indexer_touchInstructionText: () =>
    '[PX][Double tap and hold to enter gesture mode, then drag up or down to adjust value. éëžéëžéëžéëžéëžéëžé]',
  info: () => '[PX][Info é]',
  inputDateMask_date_cleared: () => '[PX][Date cleared é]',
  inputDateMask_dayPlaceholder: () => '[PX][dd é]',
  inputDateMask_empty_segment: () => '[PX][Empty é]',
  inputDateMask_monthPlaceholder: () => '[PX][mm é]',
  inputDateMask_yearPlaceholder: () => '[PX][yyyy é]',
  inputDatePicker_dateRangeOverflowMessageDetail: (p: { max: string }) =>
    "[PX][Enter a date that's on or before " + p['max'] + '. éëžéëž]',
  inputDatePicker_dateRangeUnderflowMessageDetail: (p: { min: string }) =>
    "[PX][Enter a date that's on or after " + p['min'] + '. éëžéëž]',
  inputDatePicker_dateRestrictionMessageDetail: () => '[PX][Enter an available date. éë]',
  inputDatePicker_instruction: () => '[PX][Press Tab to access the calendar. éëžé]',
  inputDatePicker_selectDate: () => '[PX][Select a date é]',
  inputMonthMask_dateRangeOverflowMessageDetail: (p: { max: string }) =>
    "[PX][Enter a month and year that's on or before " + p['max'] + '. éëžéëžéëž]',
  inputMonthMask_dateRangeUnderflowMessageDetail: (p: { min: string }) =>
    "[PX][Enter a month and year that's on or after " + p['min'] + '. éëžéëžéëž]',
  inputNumber_converterParseError: () => '[PX][Enter a number. é]',
  inputNumber_decrease: () => '[PX][Decrease é]',
  inputNumber_increase: () => '[PX][Increase é]',
  inputPassword_hidden: () => '[PX][Password Hidden é]',
  inputPassword_hide: () => '[PX][Hide Password é]',
  inputPassword_show: () => '[PX][Show Password é]',
  inputSensitiveText_hidden: () => '[PX][Sensitive text hidden é]',
  list_msgFetchCompleted: () => '[PX][Loaded é]',
  list_msgFetchingData: () => '[PX][Loading é]',
  list_suggestion: () => '[PX][Suggestion é]',
  messageToast_allMessagesClosed: () => '[PX][All toast messages are closed. éëžé]',
  message_close: () => '[PX][Close é]',
  message_confirmation: () => '[PX][Success é]',
  message_error: () => '[PX][Error é]',
  message_info: () => '[PX][Info é]',
  message_navigationFromMessagesRegion: () =>
    '[PX][Entering messages region. Press F6 to navigate back to prior focused element. éëžéëžéëžéëžéëžéëž]',
  message_navigationToMessagesRegion: () =>
    '[PX][Messages region has new messages. Press F6 to navigate to the most recent message region. éëžéëžéëžéëžéëžéëžéëž]',
  message_warning: () => '[PX][Warning é]',
  noData_message: () => '[PX][No items to display é]',
  overflowItemLabel: () => '[PX][More Tabs é]',
  plural_separator: () => ', ',
  progressIndeterminate: () => '[PX][In Progress é]',
  radio_helpForRadio: () => '[PX][Help for radio button é]',
  radio_requiredMessageDetail: () => '[PX][Select a value. é]',
  selectMultiple_apply: () => '[PX][Apply é]',
  selectMultiple_back: () => '[PX][Back é]',
  selectMultiple_countPlus: (p: { COUNT: string }) => p['COUNT'] + '+',
  selectMultiple_highlightSelectedTagsInstructionText: () =>
    '[PX][Use left and right arrow keys to highlight selected values. éëžéëžéëžéëž]',
  selectMultiple_removeSelectedTagInstructionText: () =>
    '[PX][Press Backspace or Delete to remove the selected value. éëžéëžéëžéë]',
  selectMultiple_selectedValues: () => '[PX][Selected values é]',
  selectMultiple_showSelectedValues: () => '[PX][Show selected values only. éë]',
  selectMultiple_valuesSelected: (p: { VALUE_COUNT: string }) =>
    '[PX][' + p['VALUE_COUNT'] + ' values selected. éëžé]',
  select_addToList: () => '[PX][Add to list é]',
  select_addToListAvailable: () => '[PX][Add to list available é]',
  select_moreSearchOptions: () => '[PX][More search options é]',
  select_moreSearchOptionsAvailable: () => '[PX][More search options available éëž]',
  select_noMatchesFound: () => '[PX][No matches found. é]',
  select_oneMatchFound: () => '[PX][One match found é]',
  select_requiredMessageDetail: () => '[PX][Select a value. é]',
  select_sizeMatchesFound: (p: { TOTAL_SIZE: string }) =>
    '[PX][' + p['TOTAL_SIZE'] + ' matches found éë]',
  select_sizeOrMoreMatchesFound: (p: { TOTAL_SIZE: string }) =>
    '[PX][' + p['TOTAL_SIZE'] + ' or more matches found éëžéë]',
  selectorAll_deselectAll: () => '[PX][Deselect all é]',
  selectorAll_selectAll: () => '[PX][Select all é]',
  selector_selected: () => '[PX][Checkbox checked é]',
  selector_unselected: () => '[PX][Checkbox not checked é]',
  tabBarNavigationList_removeCueText: () => '[PX][Removable é]',
  timeComponent_tooltipZoomIn: () => '[PX][Zoom In é]',
  timeComponent_tooltipZoomOut: () => '[PX][Zoom Out é]',
  train_current: () => '[PX][Current é]',
  train_message_type: () => '[PX][Message Type é]',
  train_not_visited: () => '[PX][Not visited é]',
  train_status: (p: { currentStep: string; numberOfSteps: string }) =>
    '[PX][Step ' + p['currentStep'] + ' out of ' + p['numberOfSteps'] + ' éëžéëžé]',
  train_visited: () => '[PX][Visited é]',
  userAssistance_learnMore: () => '[PX][Learn more é]',
  userAssistance_required: () => '[PX][Required é]',
  vis_clearSelection: () => '[PX][Clear Selection é]',
  vis_drillable: () => '[PX][Drillable é]',
  vis_labelAndValue: (p: { LABEL: string; VALUE: string }) => p['LABEL'] + ': ' + p['VALUE'],
  vis_labelCountWithTotal: (p: { itemCount: string; totalCount: string }) =>
    '[PX][' + p['itemCount'] + ' out of ' + p['totalCount'] + ' éëžé]',
  vis_marqueeSelectTooltip: () => '[PX][Marquee select é]',
  vis_marqueeZoomTooltip: () => '[PX][Marquee zoom é]',
  vis_noData: () => '[PX][No data to display é]',
  vis_panTooltip: () => '[PX][Pan é]',
  vis_stateLoaded: () => '[PX][Loaded é]',
  vis_stateLoading: () => '[PX][Loading é]',
  vis_stateSelected: () => '[PX][Selected é]',
  vis_stateUnselected: () => '[PX][Unselected é]',
  warn: () => '[PX][Warning é]'
};
export default bundle;
